// Modules
import React from 'react';

// Components
import Spinner from './Spinner';

// Styles
import styles from './Loader.module.scss';

const Loader = (props) => {
  const { children, heading } = props;

  return (
    <div className={styles.container}>
      <Spinner size='lg' />

      {children ? (
        children
      ) : (
        <h3 className={styles.heading}>
          {heading ? heading : 'Processing...'}
        </h3>
      )}
    </div>
  );
};

export default Loader;
